import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar.js";
import Footer from "./components/Footer.js";
import ScrollToTop from "./components/ScrollToTop.jsx"; // 👈 Import this

// Page imports
import Home from "./pages/home.js";
import About from "./pages/about.js";
import CaseStudies from "./pages/CaseStudies.js";
import Contact from "./pages/contact.js";

// Services imports
import Services from "./pages/services/services.js";
import WebDevelopment from "./pages/services/web-development";
import WebRedevelopment from "./pages/services/web-redevelopment.js";
import EcommerceServices from "./pages/services/ecommerce-services";
import HardwareNetworking from "./pages/services/hardware-networking";
import MobileApplication from "./pages/services/mobile-application";
import SoftwareDevelopment from "./pages/services/software-development";
import WebMaintenance from "./pages/services/web-maintenance";
import WebPromotionSEO from "./pages/services/web-promotion-seo";
import AIAgriculture from "./pages/services/ai-agriculture";
import AIHealthcare from "./pages/services/ai-healthcare";
import AISurveillance from "./pages/services/ai-surveillance";
import ItConsulting from "./pages/services/it-consulting";

// Legal pages
import Privacy from './pages/Privacy.js';
import Terms from "./pages/Terms.js";

import "./styles/global.css";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* 👈 Scroll to top on route change */}
      <Navbar />
      <Routes>
        {/* Main routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        
        {/* Services routes */}
        <Route path="/services" element={<Services />} />
        <Route path="/services/web-development" element={<WebDevelopment />} />
        <Route path="/services/web-redevelopment" element={<WebRedevelopment />} />
        <Route path="/services/ecommerce-services" element={<EcommerceServices />} />
        <Route path="/services/hardware-networking" element={<HardwareNetworking />} />
        <Route path="/services/mobile-application" element={<MobileApplication />} />
        <Route path="/services/software-development" element={<SoftwareDevelopment />} />
        <Route path="/services/web-maintenance" element={<WebMaintenance />} />
        <Route path="/services/web-promotion-seo" element={<WebPromotionSEO />} />
        <Route path="/services/ai-agriculture" element={<AIAgriculture />} />
        <Route path="/services/ai-healthcare" element={<AIHealthcare />} />
        <Route path="/services/ai-surveillance" element={<AISurveillance />} />
        <Route path="/services/it-consulting" element={<ItConsulting />} />

        {/* 404 catch-all route */}
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
